// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import { auth } from '../auth.js'

import Login from '../views/ViewLogin.vue'
import Register from '../views/ViewRegister.vue'
import ViewPrincipal from '../views/ViewPrincipal.vue'
import ViewMinhasInformacoes from '@/views/ViewMinhasInformacoes.vue'
import AlterarSenha from '@/views/AlterarSenha.vue'
import ViewInbox from '@/views/ViewInbox.vue'
import BuyCoins from '../views/BuyCoins.vue'
import BuyCoinsInter from '@/views/BuyCoinsInter.vue'
import ViewRoleta from '@/views/ViewRoleta.vue'
import ViewColeta from '@/views/ViewColeta.vue'
import ViewCassino from '@/views/ViewCassino.vue'
import ConfirmRegistration from '@/views/ConfirmRegistration.vue'
import ViewDownload from '@/views/ViewDownload.vue'
import ForgotPassword from '@/views/ForgotPassword.vue'
import ResetPassword from '@/views/ResetPassword.vue'
import ViewWikia from '@/views/ViewWikia.vue'
import ViewRanked from '@/views/ViewRanked.vue'
import ViewAlquimia from '@/views/ViewAlquimia.vue'
import ViewAtualizacoes from '@/views/ViewAtualizacoes.vue'
import ViewEscala from '@/views/ViewEscala.vue'
import ChessMultiplayer from '@/components/ChessMultiplayer.vue'
import ViewMarketPlace from '@/views/ViewMarketPlace.vue'
import ViewServicos from '@/views/ViewServicos.vue'
import ConfirmEmailChange from '@/views/ConfirmEmailChange.vue'
/* importações rodtas de jogos de cassino */
import BlackJack from '@/components/BlackjackSolo.vue'
import BlackjackMultiplayer from '@/components/BlackjackMultiplayer.vue'


/* Importação jogo de damas */
import CheckersMultiplayer from '@/components/CheckersMultiplayer.vue'; 


const routes = [
  { path: '/', name: 'Home', component: ViewPrincipal },
  { path: '/login', name: 'Login', component: Login },
  { path: '/register', name: 'Register', component: Register },
  { path: '/download', name: 'Download', component: ViewDownload },
  { path: '/forgot-password', name: 'ForgotPassword', component: ForgotPassword },
  { path: '/reset-password', name: 'ResetPassword', component: ResetPassword },
  { path: '/confirm', name: 'ConfirmRegistration', component: ConfirmRegistration },

  // Rotas protegidas
  { path: '/informacoes', name: 'MinhasInformacoes', component: ViewMinhasInformacoes, meta: { requiresAuth: true } },
  { path: '/AlterarSenha', name: 'AlterarSenha', component: AlterarSenha, meta: { requiresAuth: true } },
  { path: '/Inbox', name: 'CaixaMensagens', component: ViewInbox, meta: { requiresAuth: true } },
  { path: '/Compra', name: 'ZenphyrCoins', component: BuyCoins, meta: { requiresAuth: true } },
  { path: '/CompraInternacional', name: 'ZenphyrCoinsInter', component: BuyCoinsInter, meta: { requiresAuth: true } },
  { path: '/Roleta', name: 'RoletaDaSorte', component: ViewRoleta, meta: { requiresAuth: true } },
  { path: '/ColetaDiaria', name: 'ColetaDiaria', component: ViewColeta, meta: { requiresAuth: true } },
  { path: '/CassinoBabama', name: 'CassinoZenphyr', component: ViewCassino, meta: { requiresAuth: true } },
  { path: '/Wikia', name: 'ViewWikia', component: ViewWikia, meta: { requiresAuth: true } },
  { path: '/Ranked', name: 'ViewRanked', component: ViewRanked, meta: { requiresAuth: true } },
  { path: '/Alquimia', name: 'ViewAlquimia', component: ViewAlquimia, meta: { requiresAuth: true } },
  { path: '/PathNotes', name: 'ViewAtualizacoes', component: ViewAtualizacoes, meta: { requiresAuth: true } },
  { path: '/Escala', name: 'ViewEscala', component: ViewEscala, meta: { requiresAuth: true } },
  { path: '/BlackjackSolo', name: 'BlackjackSolo', component: BlackJack, meta: { requiresAuth: true } },
  { path: '/BlackjackMultiplayer', name: 'BlackjackMultiplayer', component: BlackjackMultiplayer, meta:{ requiresAuth: true } },
  { path: '/ChessMultiplayer', name: 'ChessMultiplayer', component: ChessMultiplayer, meta:{ requiresAuth: true } },
  { path: '/CheckersMultiplayer', name: 'CheckersMultiplayer', component: CheckersMultiplayer, meta:{ requiresAuth: true } },
   { path: '/ViewMarketPlace', name: 'ViewMarketPlace', component: ViewMarketPlace, meta:{ requiresAuth: true } },
   { path: '/ViewServicos', name: 'ViewServicos', component: ViewServicos, meta:{ requiresAuth: true } },
   {
    path: '/confirm-email-change',
    name: 'ConfirmEmailChange',
    component: ConfirmEmailChange
  }

]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Guarda global de navegação para autenticação
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !auth.token) {
    next({ name: 'Home' })
  } else {
    next()
  }
})

// Define o título globalmente após cada navegação
router.afterEach((to) => {
  document.title = to.meta.title || 'Grand Fantasia Zephyr'
})

export default router
